import { DelegateMapEntry } from 'containers/Base/ActionDelegate';
import { App } from 'data/terra/App';
import { AppVersion } from 'data/terra/AppVersion';
import { Action } from 'redux';
import { ThunkAction } from 'redux-thunk';
import Terra from 'services/apis/terra/Terra';
import { RootState } from 'store/reducer';
import { AppSelectorState } from '../reducer';

export const SELECT_APP = 'SELECT_APP';

export interface SelectAppAction {
  type: typeof SELECT_APP;
  appId: string;
  appVersions: AppVersion[];
}

export const selectApp = (
  appId: string
): ThunkAction<void, RootState, unknown, Action<string>> => async dispatch => {
  const result = await Terra.app.fetchAppVersions(appId);
  if (result.isSuccess()) {
    const appVersions = result.get()!.data;
    dispatch({
      type: SELECT_APP,
      appId,
      appVersions,
    } as SelectAppAction);
  }

  return result;
};

export const selectAppDelegate: DelegateMapEntry<
  SelectAppAction,
  AppSelectorState
> = {
  [SELECT_APP]: (
    state: AppSelectorState,
    action: SelectAppAction
  ): AppSelectorState => {
    return {
      ...state,
      selectedApp: state.apps.find((a: App) => a.id === action.appId),
      appVersions: action.appVersions,
    };
  },
};
